import { getMyPortalClient } from './myportalClient.js'
import { parseDateInput } from './dateRangeSelection.js'

let sectionTrackingStarted = false
let lastSectionPath = ''
let lastSectionAt = 0
const SECTION_DEBOUNCE_MS = 1500

function analytix() {
  return getMyPortalClient()?.analytix
}

function currentSectionPath() {
  if (typeof window === 'undefined') return '/'
  const hash = window.location.hash || '#home'
  return hash.startsWith('#') ? hash : `#${hash}`
}

function trackSectionPageview(force = false) {
  const service = analytix()
  if (!service?.hasConsent()) return

  const path = currentSectionPath()
  const now = Date.now()
  if (!force && path === lastSectionPath && now - lastSectionAt < SECTION_DEBOUNCE_MS) {
    return
  }

  lastSectionPath = path
  lastSectionAt = now
  service.pageview({
    path,
    title: typeof document !== 'undefined' ? document.title : path,
  })
}

export function syncAnalytixConsent(granted) {
  const service = analytix()
  if (!service) return

  service.setConsent(Boolean(granted))
  if (granted) {
    trackSectionPageview(true)
    initSectionTracking()
  }
}

export function initSectionTracking() {
  if (typeof window === 'undefined' || sectionTrackingStarted) return
  sectionTrackingStarted = true

  window.addEventListener('hashchange', () => trackSectionPageview())
}

export function trackCtaClick(label = 'Jetzt reservieren', extra = {}) {
  const service = analytix()
  if (!service?.hasConsent()) return

  service.track('cta_click', { label, ...extra }, {
    path: currentSectionPath(),
  })
}

export function trackContactSubmit(extra = {}) {
  const service = analytix()
  if (!service?.hasConsent()) return

  service.track('contact_submit', { form: 'contact', ...extra }, {
    path: '#contact_us',
    title: typeof document !== 'undefined' ? document.title : '',
  })
}

export function nightsBetween(checkIn, checkOut) {
  const start = parseDateInput(checkIn)
  const end = parseDateInput(checkOut)
  if (!start || !end) return 0
  const diff = end.getTime() - start.getTime()
  return diff > 0 ? Math.round(diff / (24 * 60 * 60 * 1000)) : 0
}

export function trackBookingInquiry({ apartment, checkIn, checkOut, guestCount } = {}) {
  const service = analytix()
  if (!service?.hasConsent()) return

  const slug = apartment?.slug || apartment?.identifier || apartment?.name || ''
  service.track(
    'booking_inquiry',
    {
      apartment: slug,
      nights: nightsBetween(checkIn, checkOut),
      guest_count: guestCount || 0,
    },
    {
      path: currentSectionPath(),
      title: typeof document !== 'undefined' ? document.title : '',
    }
  )
}

export function trackCalendarSearch({ month, year, apartment, action } = {}) {
  const service = analytix()
  if (!service?.hasConsent()) return

  const slug =
    typeof apartment === 'string'
      ? apartment
      : apartment?.slug || apartment?.identifier || apartment?.name || ''

  service.track(
    'calendar_search',
    {
      month: Number(month) || 0,
      year: Number(year) || 0,
      apartment: slug,
      action: action || 'month_change',
    },
    {
      path: currentSectionPath(),
    }
  )
}
